import React, { Component } from 'react';
import {
    Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, Button, UncontrolledDropdown, DropdownToggle, DropdownMenu,
    DropdownItem, Dropdown, InputGroupAddon, InputGroup, Input, Spinner, ModalHeader, Modal, ModalFooter, ModalBody
} from 'reactstrap';
import './header.css'
import TeacherLogo from '../../../assets/Images/TeacherLogo.png'
import ParentLogo from '../../../assets/Images/ParentLogo.png'
import StudentLogo from '../../../assets/Images/StudentLogo.png'
import AssistantLogo from '../../../assets/Images/AssistantLogo.png'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { sendLogout } from '../../../redux/Action/Auth/LoginAction'
import String from '../../../assets/Locales/teacher_locales'
import { ChangeLangauge, ChangeVisitorLangauge } from '../../../redux/Action/LanguageAction'
import axios from 'axios'
import { API_ENDPOINT } from '../../../AppConfig'
import SideMenu from '../SideMenu/SideMenu'
import { Redirect, Link } from 'react-router-dom';
import driver from '../../../assets/Images/driver.jpg'
import { visit } from '../../../redux/Action/Auth/LoginAction'
import Moment from 'react-moment';
import { closeMenu, closeMenuMobile } from '../../../redux/Action/Auth/LoginAction'
import {
    initNotif, clearMsgCount, clearNotificationCount
} from '../../../redux/Action/ChatAction'


class Header extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.togglelocales = this.togglelocales.bind(this);
        this.togglemenu = this.togglemenu.bind(this);
        this.tosetTextitemggle = this.setTextitem.bind(this);
        this.togglesidenav = this.togglesidenav.bind(this);
        this.togglemobileLocales = this.togglemobileLocales.bind(this);
        this.togglemobilenotification = this.togglemobilenotification.bind(this);
        this.togglemobilemessages = this.togglemobilemessages.bind(this);
        this.toggletablet = this.toggletablet.bind(this);
        this.state = {
            closeDrop: false,
            isOpen: false,
            allNotifications: [],
            allMessages: [],
            toggle: false,
            collapsemenu: false,
            textItem: "",
            defaultlang: this.props.lang,
            dropdownlocales: false,
            dropdownnotification: false,
            dropdownmessages: false,
            dropdowntablet: false,
            redirect: false,
            noMessages: false,
            noNotifications: false,
            notificationID: null,
            modal: false,
            pageCount: 0,
            pageCountMDG: 0,
            showNotifyArrow: false,
            redirect: false,
            search: null,
            page: false,
            visitRedirect: false,
            defPage: 1,
            disabledFlag: true
        };
        this.modal = this.modal.bind(this);
    }
    modal() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }
    toggletablet() {
        this.props.closeMenu(!this.props.closemenu)
    }

    togglemobileLocales() {
        this.setState(prevState => ({
            dropdownlocales: !prevState.dropdownlocales
        }));
    }

    togglemobilenotification() {
        this.setState(prevState => ({
            dropdownnotification: !prevState.dropdownnotification
        }));
    }

    togglemobilemessages() {
        this.setState(prevState => ({
            dropdownmessages: !prevState.dropdownmessages
        }));
    }

    togglemenu() {
        this.setState(state => ({ collapsemenu: !state.collapsemenu }))
    }

    setTextitem(text) {

        this.setState({ textItem: text })
    }

    togglesidenav() {
        this.setState(state => ({ toggle: !state.toggle }));
    }
    page = 1
    FetchNotifications = (lang, page) => {
        this.setState({ noNotifications: false, pageCount: 0 })
        let uri = `${API_ENDPOINT}/notif?limit=6&page=${page}`
        let token = `Bearer ${this.props.token}`
        axios.get(uri, {
            headers: {
                'Accept-Language': lang,
                'Authorization': token
            }
        }).then(response => {
            this.setState({ allNotifications: [...this.state.allNotifications, ...response.data.data], noNotifications: true, pageCount: response.data.pageCount })
            // console.log("all notification response ", this.state.allNotifications, this.state.pageCount)
        }).catch(error => {
            // console.log("error is", error)
        })
    }
    messagePage = 1
    FetchMessages = (lang, page) => {
        this.setState({ noMessages: false })
        let uri = `${API_ENDPOINT}/chat/lastContacts?page=${page}&limit=8`
        let token = `Bearer ${this.props.token}`
        axios.get(uri, {
            headers: {
                'Accept-Language': lang,
                'Authorization': token
            }
        }).then(response => {
            this.setState({ allMessages: [...this.state.allMessages, ...response.data.data], noMessages: true, pageCountMDG: response.data.pageCount })
            // console.log("responsedescription", response.data.data)
        }).catch(error => {
            // console.log("errorMessage is", error.response.data)
       
        })
    }

    togglelocales() {
        this.setState(prevState => ({
            modallocales: !prevState.modallocales
        }));
    }

    sendLogout = () => {
        this.props.sendLogout();
    }

    JoinVisitor = () => {
        this.setState({ redirect: true })
    }
    joinAsVisitor = () => {
        this.setState({ visitRedirect: true })
    }
    componentWillMount() {
        let userType = this.props.userType
        if (!userType) {
            this.props.visit('VISITOR', JSON.parse(localStorage.getItem("VisitorsublevelID")))
        }
    }

    toggle() {
        this.props.closeMenuMobile(!this.props.menuMobile)
    }
 
    redirect(language) {
        this.setState({ defaultlang: language })
    }
    markasRead() {
        let uri = `${API_ENDPOINT}/notif/${this.state.notificationID}/read`
        let token = `Bearer ${this.props.token}`
        axios.put(uri, {}, {
            headers: {
                'Accept-Language': this.props.lang,
                'Authorization': token
            }
        }).then(response => {
            // console.log("responsedescription", response.data)
        }).catch(error => {
            // console.log("errorMessage is", error.response)
        })
    }
    handleScroll = e => {
        let element = e.target
        // let page=this.state.defPage
        if (element.scrollHeight - element.scrollTop === element.clientHeight) {
            // page=this.state.page?1:this.page++;
            this.state.defPage++
            this.FetchNotifications(this.props.lang, this.state.defPage)
            this.setState({ page: false })
        }
    }
    handleMSGScroll = e => {
        let element = e.target
        if (element.scrollHeight - element.scrollTop === element.clientHeight) {
            this.messagePage++;
            this.state.pageCountMDG > this.messagePage && this.FetchMessages(this.props.lang, this.messagePage)
        }
    }
    remove() {
        this.setState({ allMessages: [] })
    }
    removeNotification() {
        this.setState({ allNotifications: [] })
    }
    _handleKeyPress(e) {
        this.setState({ redirect: false, search: null })
        if (e.key === 'Enter') {
            this.page = 1
            this.setState({ redirect: true, search: e.target.value })
            // this.props.getsearchData(e.target.value,true)
        }
    }
    accept(id) {
        let data = {
            status: "ACCEPTED",
            parent: id
        }
        let url = `${API_ENDPOINT}/child`
        let token = `Bearer ${this.props.token}`
        axios.put(url, data, {
            headers: {
                "Accept-Language": this.props.lang,
                Authorization: token
            }
        }).then(response => {
            this.props.hideLoading()
            // console.log("Accept Parent response:", response.data)
        }).catch(err => {
            // console.log("Accept Parent error:", err.response)
        })
    }
    reject(id) {
        let data = {
            status: "REJECTED",
            parent: id
        }
        let url = `${API_ENDPOINT}/child`
        let token = `Bearer ${this.props.token}`
        axios.put(url, data, {
            headers: {
                "Accept-Language": this.props.lang,
                Authorization: token
            }
        }).then(response => {
            this.props.hideLoading()
            // console.log("Accept Parent response:", response.data)
        }).catch(err => {
            // console.log("Accept Parent error:", err.response)
        })
    }
    render() {
        let user = this.props.user
        // String.setLanguage(this.props.lang)
        // let lang = this.props.lang
        if (this.props.lang === "ar") {
            document.title = "كراسة"
            String.setLanguage('ar');
            if (this.props.lang !== this.state.defaultlang) {
                this.redirect("ar")
            }
        }
        else {
            document.title = "Korassa"
            String.setLanguage('en');
            if (this.props.lang !== this.state.defaultlang) {
                this.redirect("en")
            }
        }
        if (this.props.lang !== this.state.prevLang) {
            this.setState({ prevLang: this.props.lang })
            var moment = require('moment');
            if (this.props.lang === "ar") {
                require('moment/locale/ar');
                moment.locale("ar");
            }
            else {
                moment.locale("en");
            }
        }
        return (
            <div className="headerNavbar" id={this.props.userType === 'TEACHER' ? "teacher" : this.props.userType === 'ASSISTANT' ? "assistant" :
                this.props.userType === 'STUDENT' ? "student" : "parent"} style={{ direction: this.props.lang === 'ar' ? 'rtl' : 'ltr' }}>
                <Navbar color="white" light expand="md" fixed="top">
                    <NavbarBrand href="/" className={this.props.lang === 'ar' ? 'mr-3' : 'ml-3'} >
                        {this.props.userType === "STUDENT" ?
                            <img src={StudentLogo} alt="LOGO" /> :
                            this.props.userType === "TEACHER" ?
                                <img src={TeacherLogo} alt="LOGO" /> :
                                this.props.userType === "ASSISTANT" ?
                                    <img src={AssistantLogo} alt="LOGO" /> :
                                    this.props.userType === "GUARDIAN" ?
                                        <img src={ParentLogo} alt="LOGO" /> :
                                        <img src={StudentLogo} alt="LOGO" />
                        }
                    </NavbarBrand>

                    {/* <Dropdown className="hideLargelocalse" isOpen={this.state.dropdownlocales} toggle={this.togglemobileLocales}>
                        <DropdownToggle>
                            <i className="fa fa-globe-asia" style={{ fontSize: "20px", color: "#000" }}></i>
                        </DropdownToggle>
                        <DropdownMenu style={{ width: "auto", height: "auto", left: this.props.lang === "en" ? "-60px" : "", right: this.props.lang === "ar" ? "-70px" : "" }}
                            className={this.props.lang === "ar" ? "text-right" : "text-left"}>
                            <DropdownItem style={{ display: this.props.lang === "ar" ? "none" : "block" }}
                                onClick={() => {
                                    this.props.ChangeLangauge("ar", this.props.token)
                                    this.togglelocales()
                                }}
                            >{String.ArabicBTN}</DropdownItem>
                            <DropdownItem style={{ display: this.props.lang === "en" ? "none" : "block" }}
                                onClick={() => {
                                    this.props.ChangeLangauge("en", this.props.token)
                                    this.togglelocales()
                                }}>{String.EnglishBTN}</DropdownItem>
                        </DropdownMenu>
                    </Dropdown> */}

                    {/* <Dropdown className="hideLargelocalse" isOpen={this.state.dropdownmessages} toggle={this.togglemobilemessages}>
                        <DropdownToggle>
                          
                            <i class="far fa-envelope" style={{ fontSize: "20px", color: "#000" }} onClick={() => {
                                this.remove()
                                this.FetchMessages(this.props.lang, this.messagePage)
                                this.props.clearMsgCount()

                            }}></i>
                        </DropdownToggle>
                        <DropdownMenu className={this.props.lang === "ar" ? "text-right" : "text-left"}>
                            {
                                this.state.allMessages.length > 0 ?
                                    this.state.allMessages.map((element) => (
                                        user.id === element.from.id ?
                                            <Link to={{
                                                pathname: `/conversation`,
                                                state: { id: element.to.id, user: element.to, name: element.to.firstName + ' ' + element.to.firstName }
                                            }}>
                                                <DropdownItem style={{ padding: ".25rem 1rem", borderBottom: "1px solid #ccc", backgroundColor: element.seen ? '' : '#F1F1F1' }}>
                                                    <div style={{ width: "10%", display: "inline-block", position: "relative", top: "-10px", right: "-10px" }}>
                                                        <img className="picMessages" src={element.to.image !== "" ? API_ENDPOINT + element.to.image : driver} alt="img" />
                                                    </div>
                                                    <div style={{ width: "90%", display: "inline-block" }}>
                                                        <h6>{element.message}</h6>
                                                        <h6> <Moment date={element.createdAt} fromNow /></h6>
                                                    </div>
                                                </DropdownItem>
                                            </Link> :
                                            <Link to={{
                                                pathname: `/conversation`,
                                                state: { id: element.from.id, user: element.from, name: element.from.firstName + ' ' + element.from.firstName }
                                            }}>
                                                <DropdownItem style={{ padding: ".25rem 1rem", borderBottom: "1px solid #ccc", backgroundColor: element.seen ? '' : '#F1F1F1' }}>
                                                    <div style={{ width: "10%", display: "inline-block", position: "relative", top: "-10px", right: "-10px" }}>
                                                        <img className="picMessages" src={element.from.image !== "" ? API_ENDPOINT + element.from.image : driver} alt="img" />
                                                    </div>
                                                    <div style={{ width: "90%", display: "inline-block" }}>
                                                        <h6>{element.message}</h6>
                                                        <h6> <Moment date={element.createdAt} fromNow /></h6>
                                                    </div>
                                                </DropdownItem>
                                            </Link>

                                    ))
                                    :
                                    <div>
                                        {this.state.noMessages ? <p className="text-center pt-5" style={{
                                            color: this.props.lang === 'TEACHER' ? "#FFC85D" : this.props.lang === 'ASSISTANT' ? "#182B8B" : this.props.lang === 'STUDENT' ? "#009E2A" : "#37BBAE", fontSize: "35px"
                                        }} >{String.noMessages}</p> :
                                            <div className="w-100 text-center pt-5">
                                                <Spinner style={{ color: this.props.lang === 'TEACHER' ? "#FFC85D" : this.props.lang === 'ASSISTANT' ? "#182B8B" : this.props.lang === 'STUDENT' ? "#009E2A" : "#37BBAE" }} />
                                            </div>
                                        }
                                    </div>
                            }

                        </DropdownMenu>
                    </Dropdown> */}

                    {/* <Dropdown className="hideLargelocalse" isOpen={this.state.dropdownnotification} toggle={this.togglemobilenotification}>
                        <DropdownToggle>
                            <i className="fa fa-bell" style={{ fontSize: "20px", color: "#000" }} onClick={() => {
                                this.setState({ page: false, defPage: 1 }, () => {
                                    this.removeNotification()
                                    this.FetchNotifications(this.props.lang, this.state.defPage)
                                    this.props.clearNotificationCount()
                                })

                            }}></i>
                        </DropdownToggle>
                        <DropdownMenu className={this.state.closeDrop ? "show" : ""} style={{ textAlign: this.props.lang === "ar" ? "right" : "left", left: this.props.lang === "ar" ? "-110px" : "-150px" }} onScroll={this.handleScroll}>

                            {
                                this.state.allNotifications.length > 0 ?
                                    this.state.allNotifications.map((element) => (
                                        <DropdownItem style={{ borderBottom: "1px solid #ccc", backgroundColor: element.read ? "#FFFFFF" : "#F1F1F1" }} onClick={() => {
                                            this.setState({ notificationID: element.id, page: true, defPage: 0 }, () => {
                                                this.markasRead()
                                                console.log("Page state:", this.state.page)
                                            })
                                        }}>
                                            {console.log("notification Ement:", element, "GROUP:", element.subject)}
                                            <Link style={{ color: "#3B3B3B" }} to={{
                                                pathname: element.subjectType === "GROUP" || element.subjectType === "EXTRA_LECTURE" || element.subjectType === "GROUP_REMOVE" ?
                                                    `/groups/details/${element.subject}` : element.subjectType === "FOLLOW" ? `/StudentProfile/${element.resource.id}` : 
                                                    element.subjectType === "EXAM" ?
                                                        '/exam-details' : element.subjectType === "EXAM_STUDENT" ?
                                                            '/Online-Exams/corrected-exam' : element.subjectType === "PAYMENT" ?
                                                                '/Groups' : element.subjectType === "POST" ? `/Levels/questions/sibgleQuestion/${element.resource.id}` : '/home',
                                                state: {
                                                    groupId: element.subject,
                                                    subjectType: element.subjectType
                                                }
                                            }} className={element.subjectType==="NEW_PARENT"&&!this.state.closeDrop?'disabled-link':''}
                                            >
                                                <div style={{ width: "5%", display: "inline-block", position: "relative", top: "-33px" }}>
                                                    <span className="pointNoti" style={{ backgroundColor: this.props.lang === 'TEACHER' ? "#FFC85D" : this.props.lang === 'ASSISTANT' ? "#182B8B" : this.props.lang === 'STUDENT' ? "#009E2A" : "#37BBAE" }}></span>
                                                </div>
                                                <div style={{ width: "100%", display: "inline-block" }}>
                                                    <h6 style={{ whiteSpace: "normal", padding: "0px 4px" }}>{element.description}</h6>
                                                    <h6 style={{ direction: "ltr" }}> <Moment date={element.createdAt} fromNow /></h6>
                                                </div>
                                            </Link>
                                            {element.subjectType === "NEW_PARENT" && !element.read &&<span className={this.page.lang==="ar"?"parent-options":"parent-options-en"}>
                                                                <Button id="accept-parent" onClick={() => {
                                                                    this.setState({ disabledFlag: false, closeDrop: true }, () => {
                                                                        this.accept(element.resource.id)
                                                                        console.log("this.state.closeDrop", this.state.closeDrop)
                                                                    })
                                                                }} >{String.accept}</Button>
                                                                <Button id="reject-parent" onClick={() => {
                                                                    this.setState({ disabledFlag: false, closeDrop: true }, () => {
                                                                        this.reject(element.resource.id)
                                                                    })
                                                                }} >{String.reject}</Button>

                                                            </span>}
                                        </DropdownItem>
                                    ))
                                    :
                                    <div>
                                        {this.state.noNotifications ? <p className="text-center pt-5" style={{
                                            color: this.props.lang === 'TEACHER' ? "#FFC85D" : this.props.lang === 'ASSISTANT' ? "#182B8B" : this.props.lang === 'STUDENT' ? "#009E2A" : "#37BBAE", fontSize: "35px"
                                        }} >{String.noNotifications}</p> :
                                            <div className="w-100 text-center pt-5">
                                                <Spinner style={{ color: this.props.lang === 'TEACHER' ? "#FFC85D" : this.props.lang === 'ASSISTANT' ? "#182B8B" : this.props.lang === 'STUDENT' ? "#009E2A" : "#37BBAE" }} />
                                            </div>
                                        }
                                    </div>
                            }

                        </DropdownMenu>
                    </Dropdown> */}

                    {/* <Dropdown className="showtablet" isOpen={this.props.closemenu} toggle={this.toggletablet}>
                        <DropdownToggle className="iconsidemenu">
                            <i className="fa fa-list-ul"></i>
                        </DropdownToggle>
                        <DropdownMenu className={this.props.lang === "ar" ? "text-right" : "text-left"} >
                            <SideMenu />
                        </DropdownMenu>
                    </Dropdown> */}

                    <NavbarToggler onClick={this.toggle} />

                    <Collapse isOpen={this.props.menuMobile} navbar >
                        {/* className={this.props.lang === "ar" ? "profile-tabs-en" : "profile-tabs-en"} */}
                        <Nav className={this.props.lang === 'ar' ? 'mr-auto' : 'ml-auto'} navbar>
                            {/* {this.props.lang === "VISITOR" && */}
                            <NavItem style={{ direction: this.props.lang === "ar" ? "ltr" : "rtl", marginLeft: this.props.lang === "ar" ? "10px" : "" }}>
                                <InputGroup >
                                    <InputGroupAddon addonType="prepend"><i style={{ backgroundColor: "#F5F5F5", padding: "10px" }} className="fa fa-search"></i></InputGroupAddon>
                                    <Input className="SearchInput" placeholder={String.SearchInput}
                                        style={{ textAlign: this.props.lang === "ar" ? "right" : "left" }}
                                        onKeyPress={e => this._handleKeyPress(e)} />
                                </InputGroup>
                            </NavItem>
                            {/* } */}
                            {this.props.userType  !== 'VISITOR' &&
                                <UncontrolledDropdown nav inNavbar className="ml-3 showlocalelarge">
                                    <DropdownToggle nav>
                                        <div className="conterndropwdown">
                                            <div className="dropdownicons" onClick={() => {
                                                this.remove()
                                                this.FetchMessages(this.props.lang, this.messagePage)
                                                this.props.clearMsgCount()

                                            }}>
                                                <i className="fa fa-envelope" style={{ fontSize: "20px", color: "#000" }} ></i>
                                                <span className="iconNumber"
                                                    id={this.props.lang === "ar" ? "iconnumbposAR" : "iconnumbposEN"} >{this.props.chatCounter}</span>
                                            </div>
                                        </div>
                                    </DropdownToggle>
                                    <DropdownMenu style={{ textAlign: this.props.lang === "ar" ? "right" : "left", left: this.props.lang === "ar" ? "-110px" : "-150px" }} onScroll={this.handleMSGScroll}>

                                        {
                                            this.state.allMessages.length > 0 ?
                                                this.state.allMessages.map((element) => (
                                                    user.id === element.from.id ?
                                                        <Link to={{
                                                            pathname: `/conversation`,
                                                            state: { id: element.to.id, user: element.to, name: element.to.firstName + ' ' + element.to.secondName }
                                                        }}>
                                                            <DropdownItem style={{ padding: ".25rem 1rem", borderBottom: "1px solid #ccc", backgroundColor: element.seen ? '' : '#F1F1F1' }}>
                                                                <div style={{ width: "10%", display: "inline-block", position: "relative", top: "-10px", right: "-10px" }}>
                                                                    <img className="picMessages" src={element.to.image !== "" ? API_ENDPOINT + element.to.image : driver} alt="img" />
                                                                </div>
                                                                <div style={{ width: "90%", display: "inline-block" }}>
                                                                    <h6>{element.message}</h6>
                                                                    <h6> <Moment date={element.createdAt} fromNow /></h6>
                                                                </div>
                                                            </DropdownItem>
                                                        </Link> :
                                                        <Link to={{
                                                            pathname: `/conversation`,
                                                            state: { id: element.from.id, user: element.from, name: element.from.firstName + ' ' + element.from.secondName }
                                                        }}>
                                                            <DropdownItem style={{ padding: ".25rem 1rem", borderBottom: "1px solid #ccc", backgroundColor: element.seen ? '' : '#F1F1F1' }}>
                                                                <div style={{ width: "10%", display: "inline-block", position: "relative", top: "-10px", right: "-10px" }}>
                                                                    <img className="picMessages" src={element.from.image !== "" ? API_ENDPOINT + element.from.image : driver} alt="img" />
                                                                </div>
                                                                <div style={{ width: "90%", display: "inline-block" }}>
                                                                    <h6>{element.message}</h6>
                                                                    <h6> <Moment date={element.createdAt} fromNow /></h6>
                                                                </div>
                                                            </DropdownItem>
                                                        </Link>

                                                ))
                                                :
                                                <div>
                                                    {this.state.noMessages ? <p className="text-center pt-5" style={{
                                                        color: this.props.lang === 'TEACHER' ? "#FFC85D" : this.props.lang === 'ASSISTANT' ? "#182B8B" : this.props.lang === 'STUDENT' ? "#009E2A" : "#37BBAE", fontSize: "35px"
                                                    }} >{String.noMessages}</p> :
                                                        <div className="w-100 text-center pt-5">
                                                            <Spinner style={{ color: this.props.lang === 'TEACHER' ? "#FFC85D" : this.props.lang === 'ASSISTANT' ? "#182B8B" : this.props.lang === 'STUDENT' ? "#009E2A" : "#37BBAE" }} />
                                                        </div>
                                                    }
                                                </div>
                                        }


                                    </DropdownMenu>
                                </UncontrolledDropdown>}
                            {this.props.userType !== 'VISITOR' && <UncontrolledDropdown nav inNavbar className="ml-3 showlocalelarge">
                                <DropdownToggle nav>
                                    <div className="conterndropwdown">
                                        <div className="dropdownicons" onClick={() => {
                                            this.setState({ showNotifyArrow: true })
                                            this.removeNotification()
                                            this.FetchNotifications(this.props.lang, this.page)
                                            this.props.clearNotificationCount()

                                        }}>
                                            <i className="fa fa-bell"
                                                style={{ fontSize: "20px", color: "#000" }}></i>
                                            <span className="iconNumber" id={this.props.lang === "ar" ? "iconnumbposAR" : "iconnumbposEN"}>{this.props.count}</span>
                                        </div>
                                    </div>
                                </DropdownToggle>
                                {/* {  this.state.showNotifyArrow&&
                               <div class="triangle-up"></div>} */}
                                {/* <div className={this.props.lang === "ar" ? "profile-tabs-en" : "profile-tabs-en"}> */}
                                <DropdownMenu className={this.state.closeDrop ? "show" : ""} style={{ textAlign: this.props.lang === "ar" ? "right" : "left", left: this.props.lang === "ar" ? "-110px" : "-150px",boxShadow:"7px 5px 10px #8e8e8e" }} onScroll={this.handleScroll}

                                >

                                    {
                                        this.state.allNotifications.length > 0 ?
                                            this.state.allNotifications.map((element) => (
                                                <DropdownItem style={{ borderBottom: "1px solid #ccc", backgroundColor: element.read ? "#FFFFFF" : "#F1F1F1" }} onClick={() => {
                                                    this.setState({ notificationID: element.id, showNotifyArrow: false, page: true }, () => {
                                                        this.markasRead()
                                                    })
                                                }}
                                                // disabled={element.subjectType==="NEW_PARENT"}
                                                >
                                                    <Link style={{ color: "#3B3B3B" }} to={{
                                                        pathname: element.subjectType === "GROUP" || element.subjectType === "EXTRA_LECTURE" || element.subjectType === "GROUP_REMOVE" ?
                                                            `/groups/details/${element.subject}` : element.subjectType === "FOLLOW" ? `/StudentProfile/${element.resource.id}` : element.subjectType === "EXAM" ?
                                                                '/exam-details' : element.subjectType === "EXAM_STUDENT" ?
                                                                    '/Online-Exams/corrected-exam' : element.subjectType === "PAYMENT" ?
                                                                        '/Groups' : element.subjectType === "POST" ? `/Levels/questions/sibgleQuestion/${element.resource.id}` :
                                                                        element.subjectType === "GROUPREQUEST"?this.props.userType==="TEACHER" ?'/group/changeRequests':`/groups/details/${element.subject}`:
                                                                        element.subjectType === "NEW_STUDENT"?'/studentsparent':
                                                                        element.subjectType === "TIMELINE"?`/post/${element.subject}`:
                                                                        '/home',
                                                        state: {
                                                            groupId: element.subject,
                                                            subjectType: element.subjectType
                                                        }
                                                    }}
                                                    className={element.subjectType==="NEW_PARENT"&&!this.state.closeDrop?'disabled-link':''}
                                                    // disabled={element.subjectType==="NEW_PARENT"}
                                                    >
                                                        <div style={{ width: "5%", display: "inline-block", position: "relative", top: element.subjectType === "NEW_PARENT" ? "-38px" : "-33px" }}>
                                                            <span className="pointNoti" style={{ backgroundColor: this.props.lang === 'TEACHER' ? "#FFC85D" : this.props.lang === 'ASSISTANT' ? "#182B8B" : this.props.lang === 'STUDENT' ? "#009E2A" : "#37BBAE" }}></span>
                                                        </div>
                                                        <div style={{ width: "100%", display: "inline-block" }}>
                                                            <h6 style={{ whiteSpace: "normal", padding: "0px 4px" }}>{element.description}</h6>
                                                            <h6 style={{ direction: "ltr" }}> <Moment date={element.createdAt} fromNow /></h6>
                                                            {/* {element.subjectType === "NEW_PARENT" && !element.read && <span className="parent-options">
                                                                <Button id="accept-parent" onClick={() => {
                                                                    this.setState({ disabledFlag: false, closeDrop: true }, () => {
                                                                        this.accept(element.resource.id)
                                                                        console.log("this.state.closeDrop", this.state.closeDrop)
                                                                    })
                                                                }} >{String.accept}</Button>
                                                                <Button id="reject-parent" onClick={() => {
                                                                    this.setState({ disabledFlag: false, closeDrop: true }, () => {
                                                                        this.reject(element.resource.id)
                                                                    })
                                                                }} >{String.reject}</Button>

                                                            </span>} */}
                                                        </div>
                                                    </Link>
                                                    {
                                                    element.subjectType === "NEW_PARENT" && !element.read &&
                                                    <span className={this.page.lang==="ar"?"parent-options":"parent-options-en"}>
                                                                <Button id="accept-parent" onClick={() => {
                                                                    this.setState({ disabledFlag: false, closeDrop: true }, () => {
                                                                        this.accept(element.resource.id)
                                                                    })
                                                                }} >{String.accept}</Button>
                                                                <Button id="reject-parent" onClick={() => {
                                                                    this.setState({ disabledFlag: false, closeDrop: true }, () => {
                                                                        this.reject(element.resource.id)
                                                                    })
                                                                }} >{String.reject}</Button>

                                                            </span>} 
                                                </DropdownItem>
                                            ))
                                            :
                                            <div>
                                                {this.state.noNotifications ? <p className="text-center pt-5" style={{
                                                    color: this.props.lang === 'TEACHER' ? "#FFC85D" : this.props.lang === 'ASSISTANT' ? "#182B8B" : this.props.lang === 'STUDENT' ? "#009E2A" : "#37BBAE", fontSize: "35px"
                                                }} >{String.noNotifications}</p> :
                                                    <div className="w-100 text-center pt-5">
                                                        <Spinner style={{ color: this.props.lang === 'TEACHER' ? "#FFC85D" : this.props.lang === 'ASSISTANT' ? "#182B8B" : this.props.lang === 'STUDENT' ? "#009E2A" : "#37BBAE" }} />
                                                    </div>
                                                }
                                            </div>
                                    }

                                </DropdownMenu>
                                {/* </div> */}
                            </UncontrolledDropdown>}
                            {this.props.userType !== 'VISITOR' ? <UncontrolledDropdown nav inNavbar className="ml-3 showlocalelarge">
                                <DropdownToggle nav>
                                    <div className="conterndropwdown">
                                        <div className="dropdownicons">
                                            <i className="fa fa-globe-asia" style={{ fontSize: "20px", color: "#000" }}></i>
                                        </div>
                                    </div>
                                </DropdownToggle>
                                <DropdownMenu style={{ width: "auto", height: "auto" }}
                                    className={this.props.lang === "ar" ? "text-right" : "text-left"}>
                                    <DropdownItem style={{ display: this.props.lang === "ar" ? "none" : "block" }} onClick={() => {
                                        this.props.ChangeLangauge("ar", this.props.token)
                                        this.togglelocales()
                                    }}>
                                        {String.ArabicBTN}
                                    </DropdownItem>
                                    <DropdownItem style={{ display: this.props.lang === "en" ? "none" : "block" }} onClick={() => {
                                        this.props.ChangeLangauge("en", this.props.token)
                                        this.togglelocales()
                                    }}>
                                        {String.EnglishBTN}
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown> :
                                <UncontrolledDropdown nav inNavbar className="ml-3 showlocalelarge">
                                    <DropdownToggle nav>
                                        <div className="conterndropwdown">
                                            <div className="dropdownicons">
                                                <i className="fa fa-globe-asia" style={{ fontSize: "20px", color: "#000" }}></i>
                                            </div>
                                        </div>
                                    </DropdownToggle>
                                    <DropdownMenu style={{ width: "auto", height: "auto" }}
                                        className={this.props.lang === "ar" ? "text-right" : "text-left"}>
                                        <DropdownItem style={{ display: this.props.lang === "ar" ? "none" : "block" }} onClick={() => {
                                            this.props.ChangeVisitorLangauge("ar", this.props.token)
                                            this.togglelocales()
                                        }}>
                                            {String.ArabicBTN}
                                        </DropdownItem>
                                        <DropdownItem style={{ display: this.props.lang === "en" ? "none" : "block" }} onClick={() => {
                                            this.props.ChangeVisitorLangauge("en", this.props.token)
                                            this.togglelocales()
                                        }}>
                                            {String.EnglishBTN}
                                        </DropdownItem>
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            }
                            <NavItem className="largehide"
                                style={{ textAlign: this.props.lang === "ar" ? "right" : "" }} >
                                <SideMenu />
                            </NavItem>

                            {/* <NavItem className="largehide"
                                style={{ textAlign: this.props.lang === "ar" ? "right" : "" }} >
                                <Button>{String.AccountBTN}</Button>
                            </NavItem> */}

                            {this.props.lang !== "VISITOR" ?

                                <NavItem className="hidelogOUT"
                                    style={{ textAlign: this.props.lang === "ar" ? "right" : "" }}>
                                    <Button
                                        onClick={this.modal}
                                    //  onClick={this.sendLogout}
                                    >{String.LogoutBTN}</Button>
                                </NavItem> :
                                <NavItem className="hidelogOUT"
                                    style={{ textAlign: this.props.lang === "ar" ? "right" : "" }}>
                                    <Button onClick={this.joinAsVisitor}>{String.JoinBTN}</Button>
                                </NavItem>
                            }
                        </Nav>
                    </Collapse>
                    {this.state.redirect && <Redirect to="/registeration" />}
                </Navbar>
                <Modal id="specialModal" isOpen={this.state.modal} toggle={this.modal} className="deleteReq logout-conf" style={{ textAlign: "center" }}>
                    <ModalFooter id="specialModalFooter" style={{ direction: this.props.lang === "ar" ? "rtl" : "" }}>
                        <h3>{String.confirmation}</h3>
                        <div>
                            <Button color="primary" onClick={this.sendLogout}>{String.confirm}</Button>{' '}
                            <Button style={{ background: "none", backgroundColor: "rgb(181, 0, 0)", }} onClick={this.modal}>{String.CancelBTN}</Button>
                        </div>
                    </ModalFooter>
                </Modal>
                {
                    this.state.redirect && <Redirect to={{
                        pathname: '/Search',
                        state: {
                            search: this.state.search,
                        }
                    }} />
                }
                {
                    this.state.visitRedirect && <Redirect to={{
                        pathname: '/registeration',
                        state: {

                        }
                    }} />
                }
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        userType: state.login.userType,
        user: state.login.user,
        token: state.login.token,
        lang: state.lang.lang,
        count: state.chat.notifCount,
        chatCounter: state.chat.cahtCount,
        closemenu: state.login.closemenu,
        menuMobile: state.login.menuMobile
    }
}
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        // LoginRequest,
        // IntializeToken,
        ChangeLangauge,
        sendLogout,
        closeMenuMobile,
        visit, ChangeVisitorLangauge, initNotif,
        clearMsgCount, clearNotificationCount,
        closeMenu
    }
    , dispatch
)

export default (connect(mapStateToProps, mapDispatchToProps))(Header);